import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-stone-100 px-5 py-20 sm:py-28" data-id="element-19" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-20" data-mp="pm2bpwd5bfh1">
        <h2 className="text-center font-serif text-[1.6rem] font-black leading-tight tracking-tight text-stone-900 sm:text-4xl" data-id="element-21" data-mp="avld0krwb3nu">
          <span aria-hidden="true" data-id="element-22" data-mp="fsv8ah1yu9jl">🎁 </span>5 Bonos Exclusivos
        </h2>
        <p className="mt-2 text-center text-sm text-stone-600" data-id="element-23" data-mp="1u5bz3mz0dwa">
          Incluidos <span className="font-bold text-red-600" data-id="element-24" data-mp="5w0ci5x2un90">GRATIS</span> con
          tu compra
        </p>

        <ol className="mt-9 space-y-4" data-id="element-25" data-mp="3o1lgyw505tlk">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="flex items-center gap-4 rounded-2xl bg-white p-4 shadow-sm sm:gap-5 sm:p-5" data-id="element-26" data-mp="3o3y6pvh05896" data-mpi={index}>
              <div className="relative shrink-0" data-id="element-27" data-mp="1martlmorw830">
                <img src={bonus.cover} alt={`Cuadernillo del bono ${index + 1}: ${bonus.title}`} className="h-28 w-[5.25rem] object-contain mix-blend-multiply sm:h-32 sm:w-24" loading="lazy" data-id="element-28" data-mp="1r9347zmw6mma" />
                <span className="absolute -left-1 top-0 flex h-7 w-7 items-center justify-center rounded-full bg-red-600 font-serif text-xs font-bold text-white shadow-sm" data-id="element-29" data-mp="3ddiqiulcjj0x">
                  {index + 1}
                </span>
              </div>
              <div className="min-w-0 flex-1" data-id="element-30" data-mp="2zglr44r5wt8f">
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1" data-id="element-31" data-mp="2zhojkh44v3qg">
                  <h3 className="font-serif text-base font-bold leading-snug text-stone-900" data-id="element-32" data-mp="2ui2749w4prip">
                    {bonus.title}
                  </h3>
                  <span className="rounded-full bg-red-50 px-2.5 py-0.5 text-[10px] font-extrabold uppercase tracking-[0.12em] text-red-600" data-id="element-33" data-mp="33gnv4kkddyqv">
                    Gratis
                  </span>
                </div>
                <p className="mt-1.5 text-sm leading-relaxed text-stone-600" data-id="element-34" data-mp="irq06l3wim8m">
                  {bonus.text}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}